import styled from 'styled-components';
import { rgba } from 'polished';
import { primary, neutral, white } from '../../style/colors';

export const SidebarContainer = styled.div`
  padding: 20px 16px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: linear-gradient(to bottom, ${neutral[50]}, ${neutral[100]});
  
  /* Custom scrollbar - subtle neutral */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${neutral[300]};
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: ${neutral[400]};
  }
`;

export const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 3px solid ${primary[500]};
  flex-shrink: 0;
`;

export const FilterTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: ${neutral[900]};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;

  i {
    font-size: 22px;
    color: ${primary[500]};
  }
`;

export const ResetButton = styled.button`
  background: ${white};
  border: 2px solid ${primary[500]};
  color: ${primary[500]};
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border-radius: 8px;
  transition: all 0.2s;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    background: ${primary[500]};
    color: ${white};
    transform: translateY(-1px);
    box-shadow: 0 4px 8px ${rgba(primary[500], 0.3)};
  }

  &:active {
    transform: translateY(0);
  }

  i {
    font-size: 16px;
  }
`;

export const ResultCount = styled.div`
  padding: 8px 0;
  margin-bottom: 16px;
  font-size: 13px;
  color: ${neutral[400]};
  font-weight: 500;
  text-align: left;
`;
